import type { EventTrackingDecorator } from '@change-corgi/core/eventTracker';

import { isDarkModeApplied } from '#src/app/shared/hooks/dom';

export function createDarkModeAppliedDecorator(): EventTrackingDecorator {
	return {
		async getEventTrackingData(): Promise<Readonly<Record<string, unknown>>> {
			return Promise.resolve({
				dark_mode: isDarkModeApplied(),
			});
		},
	};
}
